<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>
    @if(data?.count > 1) {
      Decline {{ data.count }} Access Requests
    } @else {
      Decline Access Request
    }
  </h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <p class="mt-3">
    @if(data?.count > 1) {
      The selected people will not be given access to this account.
    } @else {
      <b>{{ data?.name }}</b> will not be given access to this account.
    }
  </p>

  <p class="text-muted">
    The reason below is shown to the person who requested access, so they know what to do next. It is
    optional, but a declined request with no explanation usually turns into a support enquiry.
  </p>

  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Reason (optional)</mat-label>
    <textarea
      matInput
      [(ngModel)]="reason"
      name="reason"
      rows="3"
      [maxlength]="maxLength"
      placeholder="For example: we could not confirm you work here. Please contact your manager."></textarea>
    <mat-hint align="end">{{ reason.length }} / {{ maxLength }}</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onConfirm()">
      <mat-icon>block</mat-icon> Decline Request
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onCancel()">
      <mat-icon>close</mat-icon> Cancel
    </button>
  </div>
</mat-dialog-actions>
